module.exports = __webpack_public_path__ + "img/sabliervert_off.efc56065.gif";